import { render, staticRenderFns } from "./MessList.vue?vue&type=template&id=b98e4010&scoped=true&"
import script from "./MessList.vue?vue&type=script&lang=js&"
export * from "./MessList.vue?vue&type=script&lang=js&"
import style0 from "./MessList.vue?vue&type=style&index=0&id=b98e4010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98e4010",
  null
  
)

export default component.exports